import React, { useState, useEffect, Fragment } from "react";
import {
  Row,
  Col,
  Text,
  Icon,
  Input,
  Radio,
  Modal,
  Popover,
  Menu,
  Dropdown,
  Spin,
  Tooltip,
} from "antd";
import ButtonComponent from "./Button_v2";
import ModalComponent from "./Modal_v2";
import ReusableInput from "../../stories/components/ReusableInput";
import { maxHeight40 } from "../../helpers/invoice_styles";
import Checkbox_v2 from "./Checkbox_v2";
import Select_v2 from "./Select_v2";
import OrderAccessorialForm from "../../components/orders/OrderAccessorialFrom";
import SectionCard from "./SectionCard";
import { FormIcon, ViewMore ,DocumentIconSvg} from "../../common/CustomIcon";
import ErrorComponent from "../../components/common/ErrorComponent";
import I18n from "../../common/I18n";
import TrashIcon from "../../../assets/images/Trash.svg";
import NoteIcon from "../../../assets/images/Note.svg";
import { fetchTechnicians } from "../../api/UsersApi";
import { getSlotInfo } from "../../components/configurations/helper";
import { fetchAccessorialDetails } from "../../api/Accessorials";
import {
  renderAcessorialIcon,
  renderAccessorialConfigLabels,
} from "../../components/billing_screen/helpers";
import { isEmpty } from "../../common/Common";

const { confirm } = Modal;

function CreateOrderAccessorial(props) {
  const {
    accountComponentAccessorial,
    config,
    haveMultipleLocations,
    displayComponents,
    isMilitaryTime = false,
    //accRef,
    getDataRef,
    updateOrderAccessorials,
    processingRecords = [],
    prevAuthorizedInfo = {},
    actionType = "create",
    handleSave = () => {},
    maximumHeight = "auto",
    isShipper = false,
    showActions = true,
    loading,
    currentOrder,
   // slotConfig
  } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [value, setValue] = useState("");
  const [orderAccessorials, setOrderAccessorials] = useState([]);
  // const [processingRecords, setProcessingRecords] = useState([]);
  const [authorizeDetails, setAuthorizeDetails] = useState({
    ...prevAuthorizedInfo,
  });
  const [slotConfig, setSlotConfig] = useState({});
  const [errors, setErrors] = useState([]);
  const [technicians, setTechnicians] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const [locked, setLocked] = useState(false); 
  useEffect(() => {
    if (currentOrder?.customer_order_details?.is_locked !== undefined) {
        setLocked(currentOrder.customer_order_details.is_locked === "true" ? true : false);
    }
}, [currentOrder]);

  // useEffect(() => {
  //   if (accRef) {
  //       accRef.current = () => processingRecords || orderAccessorials
  //   }
  // }, [processingRecords, orderAccessorials, accRef]);

  useEffect(() => {
    getUsers();
  }, []);

  useEffect(() => {
    if (["view","update"].includes(actionType)) {
      setAuthorizeDetails(prevAuthorizedInfo);
    }
  }, [prevAuthorizedInfo]);

  useEffect(() => {
    if (getDataRef) {
      getDataRef.current = () => processingRecords || orderAccessorials;
    }
  }, [processingRecords, orderAccessorials, getDataRef]);

  useEffect(() => {
    accountComponentAccessorial.forEach(
      (accessorial) => {
        const componentDefs = accessorial.componentDefs || []
        const slotObject = _.find(componentDefs, {code : 'SLOTS'});
        if(!isEmpty(slotObject)){
          getAccessorialDetails(accessorial.id, 'SLOTS');
        }
      },
    )
 },[accountComponentAccessorial])


  const getAccessorialDetails = (id, reqCode) => {
    fetchAccessorialDetails(id).then((result) => {
      if (result.success) {
        const slotConfigObj = {...slotConfig}
        const currentAccessorial = result.accessorial || [];
        const componentParams = currentAccessorial ? currentAccessorial.component_params : [];
        const slotParams = !isEmpty(reqCode) ? 
        componentParams.filter(param => param.component_code === reqCode) :
        [...componentParams];
        slotConfigObj[id] = slotParams
        setSlotConfig(
          {...slotConfigObj}
        )
      } else {
        const slotConfigObj = {...slotConfig};
        slotConfigObj[id] = []
        setSlotConfig(
          {...slotConfigObj}
        )
      }
    });
  };

  const getUsers = () => {
    fetchTechnicians().then((result) => {
      if (result.success) {
        const technicians = result.users || [];
        setTechnicians(technicians);
      } else {
        setTechnicians([]);
      }
    });
  };

  const handleChange = (e) => {
    setValue(e.target.value);
  };
  const openModal = () => {
    setIsModalOpen(true);
    setOrderAccessorials(_.cloneDeep(processingRecords));
  };
  const closeModal = () => {
    setOrderAccessorials(_.cloneDeep(processingRecords));
    setIsModalOpen(false);
  };

  const handleOnChange = (
    accountAccessorialId,
    element,
    value,
    source = ""
  ) => {
    const orderAccessorialinfo = _.cloneDeep(orderAccessorials);
    const accountAccessorialParamIndex = _.findIndex(orderAccessorialinfo, [
      "account_accessorial_id",
      accountAccessorialId,
    ]);
    if (accountAccessorialParamIndex >= 0) {
      const accessorialObj = {
        ...orderAccessorialinfo[accountAccessorialParamIndex],
      };
      if (source === "eligible_for") {
        accessorialObj.driver_pay_params = {
          ...accessorialObj.driver_pay_params,
          driver_id: value,
        };
      } else if (element === "attempted_driver_ids") {
        const attempted_driver_ids = accessorialObj.driver_pay_params
          ?.attempted_driver_ids
          ? accessorialObj.driver_pay_params.attempted_driver_ids
          : [];
        if (source >= 0) {
          if (isEmpty(value)) {
            attempted_driver_ids.splice(source, 1);
          } else if (attempted_driver_ids.length >= source) {
            attempted_driver_ids[source] = value;
          }
        } else {
          attempted_driver_ids.push(value);
        }
        accessorialObj.driver_pay_params = {
          ...accessorialObj.driver_pay_params,
          attempted_driver_ids,
        };
      } else if (element === "time_slots") {
        const values = value.split("-");
        accessorialObj.driver_pay_params = {
          ...accessorialObj.driver_pay_params,
          time_slots: { from_time: values[0], to_time: values[1] },
        };
      } else {
        accessorialObj[element] = value;
      }
      orderAccessorialinfo[accountAccessorialParamIndex] = accessorialObj;
      setOrderAccessorials(orderAccessorialinfo);
      // this.props.handleStateOnchange('orderAccessorialinfo', orderAccessorialinfo);
    }
  };

  const handleOk = () => {
    const records = _.cloneDeep(orderAccessorials);
    const errors = [];
    if (config.require_accessorial_authorization === "true") {
      orderAccessorials.forEach((acc, index) => {
        if (
          authorizeDetails[acc.accessorial_code] &&
          authorizeDetails[acc.accessorial_code].is_modified &&
          isEmpty(authorizeDetails[acc.accessorial_code].authorized_by)
        ) {
          const reqObject = _.find(accountComponentAccessorial, {
            accessorial_code: acc.accessorial_code,
          });
          errors.push(
            `${I18n.t("accessorials.authorize.by")} is required for ${
              reqObject ? reqObject.accessorial_name : acc.accessorial_code
            }`
          );
        }
        records[index] = {
          ...records[index],
          ...authorizeDetails[acc.accessorial_code],
        };
      });
    }
    if (errors.length > 0) {
      setErrors(errors);
    } else {
      if (["create", "update"].includes(actionType)) {
        setIsLoading(true);
        setOrderAccessorials([...records]);
        updateOrderAccessorials([...records]);
        setErrors([]);
        setTimeout(() => {
          setIsModalOpen(false);
          setIsLoading(false);
        }, 1000);
      } else {
        setIsLoading(true)
        updateOrderAccessorials(
          records,
          () => {
            setOrderAccessorials([...records]);
            setIsModalOpen(false);
            setIsLoading(false)
          },
          setErrors,
          () => {
            setIsLoading(false)
          },
        );
      }
    }
  };

  const handleAddOrderCompAccessorial = (
    accountAccessorialId,
    accessorialCode,
    eleValue,
    isStandardCode,
    orderAccessorial = null
  ) => {
    const orderAccessorialsInfo = orderAccessorial
      ? [...orderAccessorial]
      : orderAccessorials;
    const authorizedinfo = authorizeDetails
      ? _.cloneDeep(authorizeDetails)
      : {};
    if (!isEmpty(authorizedinfo[accessorialCode])) {
      authorizedinfo[accessorialCode] = { is_modified: false };
    }
    if (eleValue) {
      const accountAccessorial = orderAccessorialsInfo.find(
        (acc) => acc.id === accountAccessorialId
      );
      if (accountAccessorial) {
      } else {
        if (isEmpty(authorizedinfo[accessorialCode])) {
          authorizedinfo[accessorialCode] = {};
        }
        authorizedinfo[accessorialCode]["is_modified"] = true;
        const accountAccessorialObj = _.find(accountComponentAccessorial, {
          id: accountAccessorialId,
        });
        const accessorialObj = {};
        accessorialObj.account_accessorial_id = accountAccessorialId;
        accessorialObj.accessorial_code = accessorialCode;
        accessorialObj.standard_code = !isEmpty(accountAccessorialObj)
          ? accountAccessorialObj.standard_code
          : "";
        accessorialObj.component_params = [];
        accessorialObj.driver_pay_params =
          !isEmpty(accountAccessorial) && accountAccessorial.driver_pay_params
            ? accountAccessorial.driver_pay_params
            : null;
        accessorialObj.accessorial_name = accountAccessorialObj.accessorial_name;
        accessorialObj.is_master_accessorial = !isEmpty(accountAccessorialObj.rate_sheet_id) || false;
        // this.props.handleStateOnchange('orderAccessorialsInfo', [
        //   ...orderAccessorialsInfo,
        //   accessorialObj,
        // ]);
        setOrderAccessorials([...orderAccessorialsInfo, accessorialObj]);
        setAuthorizeDetails(authorizedinfo);
      }
    } else {
      const newAccountAccessorials = orderAccessorials.filter(
        (acc) => acc.account_accessorial_id !== accountAccessorialId
      );
      if (isEmpty(authorizedinfo[accessorialCode])) {
        authorizedinfo[accessorialCode] = {};
      }
      authorizedinfo[accessorialCode]["is_modified"] = true;
      setOrderAccessorials([...newAccountAccessorials]);
      setAuthorizeDetails(authorizeDetails);
      // this.props.handleStateOnchange('orderAccessorials', [...newAccountAccessorials]);
    }
    //this.updatePropValues();
  };

  const handleOnParamChange = (
    accParam,
    componentCode,
    accountAccessorialId,
    eleValue
  ) => {
    const orderAccessorialInfo = _.cloneDeep(orderAccessorials);
    const accountAccessorialParamIndex = _.findIndex(orderAccessorialInfo, [
      "account_accessorial_id",
      accountAccessorialId,
    ]);
    if (accountAccessorialParamIndex >= 0) {
      const accountAccessorialParam = _.cloneDeep(
        orderAccessorialInfo[accountAccessorialParamIndex]
      );
      const componentParams = accountAccessorialParam.component_params
        ? accountAccessorialParam.component_params
        : [];
      const componentIndex = _.findIndex(componentParams, [
        "component_code",
        componentCode,
      ]);
      let currentComponent = {};
      if (componentIndex >= 0) {
        currentComponent = componentParams[componentIndex];
        if (isEmpty(currentComponent.component_values)) {
          currentComponent.component_values = [];
        }
        const paramObjIndex = _.findIndex(currentComponent.component_values, [
          "accessorial_key",
          accParam,
        ]);
        if (paramObjIndex >= 0) {
          currentComponent.component_values[paramObjIndex].accessorial_value =
            eleValue;
        } else {
          currentComponent.component_values.push({
            accessorial_key: accParam,
            accessorial_value: eleValue,
          });
        }
        componentParams[componentIndex] = { ...currentComponent };
      } else {
        currentComponent = {
          component_code: componentCode,
          component_values: [],
        };
        currentComponent.component_values.push({
          accessorial_key: accParam,
          accessorial_value: eleValue,
        });
        componentParams.push({ ...currentComponent });
      }
      accountAccessorialParam.component_params = [...componentParams];
      orderAccessorialInfo[accountAccessorialParamIndex] = {
        ...accountAccessorialParam,
      };
      setOrderAccessorials(orderAccessorialInfo);
      // this.props.handleStateOnchange('orderAccessorials', orderAccessorials);
    }
  };

  const handleAddOrderCompStandardAccessorial = (
    accountAccessorialId,
    accessorialCode,
    eleValue,
    isStandardCode
  ) => {
    const accountAccessorial = _.find(accountComponentAccessorial, {
      id: accountAccessorialId,
    });
    if (!isEmpty(accountAccessorial)) {
      const standardCode = accountAccessorial.standard_code;
      const standardAccessorialIds = accountComponentAccessorial
        .filter(
          (accessorial) =>
            accessorial.id !== accountAccessorialId &&
            accessorial.standard_code === standardCode
        )
        .map((accessorial) => accessorial.id);
      const otherAccessorials = orderAccessorials.filter(
        (accessorial) =>
          !standardAccessorialIds.includes(accessorial.account_accessorial_id)
      );
      setOrderAccessorials(otherAccessorials);
      handleAddOrderCompAccessorial(
        accountAccessorial.id,
        accountAccessorial.accessorial_code,
        true,
        otherAccessorials
      );
      // this.setState(
      //   {
      //     orderAccessorials: otherAccessorials,
      //   },
      //   () => {
      //     this.handleAddOrderCompAccessorial(
      //       accountAccessorial.id,
      //       accountAccessorial.accessorial_code,
      //       true,
      //     )
      //   },
      // )
    }
  };
  const askConfirmMessage = (title, content, cb) => {
    confirm({
      title,
      content: <span className="">{content}</span>,
      onOk: () => {
        cb();
      },
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onCancel: () => {},
    });
  };
  const handleCheckStandardAccessorial = (
    accountAccessorialId,
    accessorialCode,
    eleValue,
    isStandardCode
  ) => {
    const authorizeDetailsInfo = authorizeDetails
      ? _.cloneDeep(authorizeDetails)
      : {};
    if (!isEmpty(authorizeDetailsInfo[accessorialCode])) {
      authorizeDetailsInfo[accessorialCode] = { is_modified: false };
    }
    const accountAccessorialObj = _.find(accountComponentAccessorial, {
      id: accountAccessorialId,
    });
    if (eleValue) {
      const otherAccessorials = orderAccessorials
        .filter(
          (accessorial) =>
            accessorial.standard_code === accountAccessorialObj.standard_code
        )
        .map((accessorial) => accessorial.accessorial_code);
      if (otherAccessorials.length > 0) {
        askConfirmMessage(
          I18n.t("messages.standard_change_confirm", {
            field: otherAccessorials.join(", "),
          }),
          I18n.t("messages.proceed_confirm"),
          () => {
            handleAddOrderCompStandardAccessorial(
              accountAccessorialId,
              accessorialCode,
              eleValue,
              isStandardCode
            );
          }
        );
      } else {
        handleAddOrderCompStandardAccessorial(
          accountAccessorialId,
          accessorialCode,
          eleValue,
          isStandardCode
        );
      }
    } else {
      const standardCode = accountAccessorialObj.standard_code;
      const standardAccessorialIds = accountComponentAccessorial
        .filter((accessorial) => accessorial.standard_code === standardCode)
        .map((accessorial) => accessorial.id);

      // const standardAccessorialIds = standardAccessorial.map(
      //   (accessorial) => accessorial.id
      // );
      const otherAccessorials = orderAccessorials.filter(
        (accessorial) =>
          !standardAccessorialIds.includes(accessorial.account_accessorial_id)
      );
      setOrderAccessorials(otherAccessorials);
      setAuthorizeDetails(authorizeDetailsInfo);
    }
  };

  const renderSlotObject = (
    paramDefinition,
    accountAccComponent,
    accessorial,
    orderAccObject,
    currentParamObj
  ) => {
    const slotConfigInfo = _.cloneDeep(slotConfig);
    const size = "small";
    const slotObject = slotConfigInfo?.[accessorial.id] ;
    const paramValues =
      slotObject &&
      slotObject.length > 0 &&
      slotObject[0].param_values &&
      slotObject[0].param_values.length > 0
        ? slotObject[0].param_values
        : {};
    const slotConfigObjects =
      paramValues.length > 0 ? paramValues?.[0].expedite_sharp || []: [];
    const isLos =
      !isEmpty(orderAccObject) && orderAccObject.accessorial_type === "los";
    const isDisabled = isEmpty(orderAccObject) || isLos;
    const value =
      orderAccObject?.driver_pay_params &&
      orderAccObject.driver_pay_params?.time_slots
        ? `${orderAccObject.driver_pay_params.time_slots.from_time}-${orderAccObject.driver_pay_params.time_slots.to_time}`
        : "";
    return (
      <Fragment>
        {slotConfigObjects && (
          <Fragment>
            <Radio.Group
              value={value}
              onChange={(e) =>
                handleOnChange(accessorial.id, "time_slots", e.target.value, "")
              }
              disabled={isDisabled}
              size={size}
            >
              {slotConfigObjects?.map((slot) => (
                <Radio value={`${slot.from_time}-${slot.to_time}`}>
                  {getSlotInfo(slot, isMilitaryTime)}
                </Radio>
              ))}
            </Radio.Group>
          </Fragment>
        )}
      </Fragment>
    );
  };

  const renderField = (
    paramDefinition,
    accountAccComponent,
    accessorial,
    orderAccObject,
    currentParamObj
  ) => {
    const size = "small";
    const isLos =
      !isEmpty(orderAccObject) && orderAccObject.accessorial_type === "los";
    const isDisabled = isEmpty(orderAccObject) || isLos;
    const { decimalPoints } = { decimalPoints: 2 };
    switch (paramDefinition.data_type) {
      case "string":
        return (
          <Row>
            <Col data-testid="charge-type-select">
              {paramDefinition.code === "charge_type" ? (
                <Radio.Group
                  value={currentParamObj && currentParamObj.accessorial_value}
                  onChange={(e) =>
                    handleOnParamChange(
                      paramDefinition.code,
                      accountAccComponent.component_code,
                      accessorial.id,
                      e.target.value
                    )
                  }
                  disabled={isDisabled}
                  size={size}
                >
                  <Radio value="percentage">Percentage</Radio>
                  <Radio value="flat">Flat</Radio>
                </Radio.Group>
              ) : paramDefinition.code === "charge_value" ? (
                <ReusableInput
                  type="number"
                  addonBefore={
                    currentConfiguration[component.code].charge_type ===
                    "flat" ? (
                      <Icon type="dollar" />
                    ) : null
                  }
                  addonAfter={
                    currentConfiguration[component.code].charge_type ===
                    "percentage" ? (
                      <Icon type="percentage" />
                    ) : null
                  }
                  value={currentConfiguration[component.code][param.code]}
                  onChange={(e) =>
                    handleOnParamChange(
                      component.code,
                      param.code,
                      e.target.value
                    )
                  }
                  className="textUpperCase"
                  min={0}
                  precision={decimalPoints}
                  defaultValue={0}
                  size={size}
                  disabled={isDisabled}
                />
              ) : (
                <ReusableInput
                  size={size}
                  value={currentParamObj && currentParamObj.accessorial_value}
                  onChange={(e) =>
                    handleOnParamChange(
                      paramDefinition.code,
                      accountAccComponent.component_code,
                      accessorial.id,
                      e.target.value
                    )
                  }
                  disabled={isDisabled}
                />
              )}
            </Col>
          </Row>
        );
      case "number":
        return (
          <Row>
            <Col>
              <ReusableInput
                data-testid="charge-input"
                type="number"
                size={size}
                value={currentParamObj && currentParamObj.accessorial_value}
                onChange={(e) =>
                  handleOnParamChange(
                    paramDefinition.code,
                    accountAccComponent.component_code,
                    accessorial.id,
                    e.target.value
                  )
                }
                disabled={isDisabled}
                min={0}
                precision={
                  paramDefinition.code === "min_charge" ||
                  paramDefinition.code === "max_charge"
                    ? decimalPoints
                    : 0
                }
              />
            </Col>
          </Row>
        );
      case "price":
        return (
          <Row>
            <Col>
              <ReusableInput
                data-testid="price-input"
                type="number"
                size={size}
                value={currentParamObj && currentParamObj.accessorial_value}
                onChange={(e) =>
                  handleOnParamChange(
                    paramDefinition.code,
                    accountAccComponent.component_code,
                    accessorial.id,
                    e.target.value
                  )
                }
                addonBefore={<Icon type="dollar" />}
                disabled={isDisabled}
                min={0}
                precision={decimalPoints}
              />
            </Col>
          </Row>
        );
      case "Boolean":
        return (
          <Row data-testid="accessorial-value">
            <Radio.Group
              value={currentParamObj && currentParamObj.accessorial_value}
              onChange={(e) =>
                handleOnParamChange(
                  paramDefinition.code,
                  accountAccComponent.component_code,
                  accessorial.id,
                  e.target.value
                )
              }
              size={size}
              disabled={isDisabled}
            >
              <Radio value>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Row>
        );
      case "Select":
        return (
          <Select_v2
            data-testid="accessorial-value-dropdown"
            showSearch
            size={size}
            value={currentParamObj && currentParamObj.accessorial_value}
            style={{ width: "100%" }}
            placeholder="Select"
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            onChange={(e) =>
              handleOnParamChange(
                paramDefinition.code,
                accountAccComponent.component_code,
                accessorial.id,
                e
              )
            }
            disabled={isDisabled}
          >
            {paramDefinition.options.map((qoption, qindex) => (
              <Select.Option
                key={qoption.option_key}
                value={qoption.option_key}
              >
                {qoption.option_value}
              </Select.Option>
            ))}
          </Select_v2>
        );
      default:
        break;
    }
  };

  const handleAuthorizeChange = (code, element, value) => {
    const authorizeDetailsInfo = authorizeDetails
      ? _.cloneDeep(authorizeDetails)
      : {};
    if (isEmpty(authorizeDetailsInfo[code])) {
      authorizeDetailsInfo[code] = {};
    }
    authorizeDetailsInfo[code][element] = value;
    setAuthorizeDetails(authorizeDetailsInfo);
  };

  const renderSelectedAccessorial = () => {
    const [visibleOptions, setVisibleOptions] = useState({});

    const handleViewMoreClick = (id) => {
      setVisibleOptions((prevState) => ({
        ...prevState,
        [id]: !prevState[id],
      }));
    };

    const handleVisibleChange = (id, flag) => {
      setVisibleOptions((prevState) => ({
        ...prevState,
        [id]: flag,
      }));
    };
    const handleRemoveClick = (id) => {
      // setOrderAccessorials((prevOrderAccessorials) =>
      //   prevOrderAccessorials.filter((acc) => acc.accessorial_code !== id)
      // );
      updateOrderAccessorials(
        processingRecords.filter((acc) => acc.accessorial_code !== id),
        null,
        setErrors
      );
    };
    const menu = (id) => (
      <Menu>
        <Menu.Item
          key="0"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            fontSize: "14px",
          }}
          onClick={() => handleRemoveClick(id)}
          data-testid="remove-button"
        >
          {actionType === "view" ? 
           <Spin spinning={loading}>
          <img src={TrashIcon} alt="" />
          <span>&nbsp;Remove</span>
          </Spin> 
            : 
          <>
          <img src={TrashIcon} alt="" />
          <span>&nbsp;Remove</span>
          </>
          } 
          
        </Menu.Item>
      </Menu>
    );

    const getAccountAccessorialConfig = (acc) => {
      const accountAcc = accountComponentAccessorial.find(
        (item) => item.id === acc.account_accessorial_id
      );
      return accountAcc || acc;
    };

    return processingRecords.map(
      (acc) => (
        (
          <Row
            key={acc.id}
            className={`accessorialRow ${
              acc.accessorial_type === "los"
                ? "accessorialRow-black"
                : "accessorialRow-hover"
            }`}
            type="flex"
            // gutter={8}
            style={{
              cursor: acc.accessorial_type !== "los" ? "pointer" : "default",
            }}
          >
            <Col xs={acc.authorized_by ? 6 : 18} className="blkCenterLeft fontSize14">
              <div 
              style={acc.authorized_by && acc.accessorial_name.length  ? {
                textOverflow: 'ellipsis',
                maxWidth: '100%',
                display: 'inline-block',
                verticalAlign: 'middle',
                whiteSpace: 'nowrap',
                overflow: 'hidden'
              }: undefined}
              >
                {renderAcessorialIcon(acc, 'is_master_accessorial', false)}
                {
                  acc.authorized_by && acc.accessorial_name.length ? (
                    <Tooltip title={`${acc.accessorial_name} (${acc.accessorial_code})`}>
                      {acc.accessorial_name} {`(${acc.accessorial_code})`}
                    </Tooltip>
                  ) : <>{acc.accessorial_name} {`(${acc.accessorial_code})`}</>
                }
                {renderAccessorialConfigLabels(getAccountAccessorialConfig(acc))}
              </div>
            </Col>
            <Col xs={acc.authorized_by ? 18 : 6} className="alignRight blkCenterRight">
              <Row type="flex" justify="end" gutter={8}>
                {acc.accessorial_type === "los" ? (
                  <Col className="blkCenterRight text-preselected">
                    Preselected
                  </Col>
                ) : (
                  <>
                    <Col className="blkCenterLeft">
                      {acc.authorized_by
                        ? `Auth. By: ${acc.authorized_by}`
                        : ""}
                    </Col>
                    <Col className="blkCenterRight" style={{ width: 32}}>
                    {acc.comments &&  <Popover
                        title="Comments"
                        content={acc.comments || "Not Available"}
                      >
                        {/* <img
                          src={NoteIcon}
                          alt=""
                          className="view-more-icon svg-icon"
                        /> */}
                       <DocumentIconSvg className="view-more-icon svg-icon"/>
                      </Popover>}
                    </Col>
                    {!isShipper && !locked && (
                    <Col className="blkCenterRight" data-testid="dropdown-options">
                      <ViewMore
                        key={acc.accessorial_code}
                        onClick={() =>
                          handleViewMoreClick(acc.accessorial_code)
                        }
                        className="view-more-icon svg-icon"
                      />
                    </Col>
                    )}
                  </>
                )}
              </Row>
              <Dropdown
                key={acc.accessorial_code}
                placement="bottomLeft"
                overlay={() => menu(acc.accessorial_code)}
                trigger={["click"]}
                visible={visibleOptions[acc.accessorial_code] || false}
                onVisibleChange={(flag) =>
                  handleVisibleChange(acc.accessorial_code, flag)
                }
              >
                <a
                  className="ant-dropdown-link"
                  onClick={(e) => {
                    e.preventDefault();
                    updateOrderAccessorials(
                      processingRecords.filter(
                        (acc) => acc.accessorial_code !== id
                      ),
                      null,
                      setErrors
                    );
                  }}
                />
              </Dropdown>
            </Col>
          </Row>
        )
      )
    );
  };

  const renderAccessorialForm = () => {
    const losAccessorials = orderAccessorials
      ? orderAccessorials
          .filter((accessorial) => accessorial.accessorial_type === "los")
          .map((accessorial) => accessorial.account_accessorial_id)
      : [];
    const additionalAccessorial = accountComponentAccessorial.filter(
      (accessorial) => !losAccessorials.includes(accessorial.id)
    );
    return (
      <ModalComponent
        data-testid="accessorial-modal"
        visible={isModalOpen}
        onCancel={closeModal}
        title="Add Accessorial"
        content={
          <Fragment>
            <Spin spinning={isLoading}>
            <OrderAccessorialForm
              data={accountComponentAccessorial}
              renderField={renderField}
              orderAccessorials={orderAccessorials}
              handleAddOrderCompAccessorial={handleAddOrderCompAccessorial}
              onChange={handleOnChange}
              handleAddOrderCompStandardAccessorial={
                handleAddOrderCompStandardAccessorial
              }
              handleCheckStandardAccessorial={handleCheckStandardAccessorial}
              displayComponents={displayComponents}
              size="small"
              pagination={{ position: "none" }}
              isReadOnly={false}
              technicians={[...technicians]}
              drivers={props.drivers}
              renderSlotObject={renderSlotObject}
              config={config}
              handleAuthorizeChange={handleAuthorizeChange}
              authorizeDetails={authorizeDetails}
              required_accessorials={[]}
              haveMultipleLocations={haveMultipleLocations}
            />
            </Spin>
            <ErrorComponent errors={[...errors]} type="error" />
          </Fragment>
        }
        closable={false}
        onOk={handleOk}
        confirmLoading={isLoading}
        okText="Add Accessorial"
        cancelText="Cancel"
        width={720}
        height={600}
        centered
        okButtonProps={{ className: "medium-btn raised", ['data-testid']: 'save-button' }}
        cancelButtonProps={{ className: "medium-btn flat", ['data-testid']: 'cancel-button' }}
      />
    );
  };

  return (
    <SectionCard
      title={
        <Fragment>{props.title ? `${props.title} ` : ""}Accessorial</Fragment>
      }
      extraActionNode={
        showActions && (
          <ButtonComponent
            data-testid="add-accessorial-button"
            // style={{ borderRadius: "4px" }}
            text={"Add Accessorial"}
            // type="secondary"
            className="outline small-btn"
            onClick={openModal}
          />
        )
      }
      maximumHeight={maximumHeight}
    >
      <div className="createOrderAccessorial">
        {renderSelectedAccessorial()}

        {/* <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h3 className="orderdetails-heading"></h3>
          <div>
            
          </div>
        </div>
      </div>
      <div> */}
        {isModalOpen && renderAccessorialForm()}
      </div>
    </SectionCard>
  );
}

export default CreateOrderAccessorial;
